import * as React from "react";

import Button, { type Props as ButtonProps } from "@/ui/atoms/Button";
import Dropdown, { type DropdownItem } from "@/ui/atoms/Dropdown";

import Icons from "../Icons";

type Props = {
  items?: DropdownItem[];
  onClick?: () => void;
  icon?: React.ReactNode | "up" | "down";
  placement?:
    | "topLeft"
    | "topCenter"
    | "topRight"
    | "bottomLeft"
    | "bottomCenter"
    | "bottomRight"
    | "top"
    | "bottom"
    | undefined;
} & ButtonProps;

const DropdownButton = ({
  items,
  onClick,
  icon = "down",
  children,
  placement,
  ...props
}: Props) => {
  return (
    <div className="flex mt-2">
      <Button
        {...props}
        className="rounded-r-none -mr-[1px] !border-0 p-2"
        onClick={() => onClick?.()}
      >
        {children}
      </Button>
      <Dropdown items={items ?? []} placement={placement}>
        <Button
          {...props}
          className="h-full rounded-l-none !border-0 !border-l !border-l-black/15 px-2.5"
        >
          <Icons.ChevronDown inheritColor size={4} />
        </Button>
      </Dropdown>
    </div>
  );
};

export default DropdownButton;
